import React from 'react';
import { ModalWindow } from 'view/molecules/ModalWindow';
import type { ActiveGuest } from 'services/aPlayer';
import { InviteGuestForm } from './components';

type Props = {
  closeHandler: () => void;
  onSuccess?: () => void;
  history?: ActiveGuest[];
  modalRef?: React.Ref<HTMLDivElement>;
};

export const InviteGuestModal = ({
  closeHandler,
  onSuccess,
  history,
  modalRef,
}: Props) => (
  <ModalWindow ref={modalRef} hideWindow={closeHandler}>
    <InviteGuestForm
      onSuccess={() => {
        closeHandler();
        onSuccess?.();
      }}
      onCancel={closeHandler}
      history={history}
    />
  </ModalWindow>
);
